<div class="loading-screen">
  <img src="./assets/icons/splash.gif" alt="Loading..." />
</div>
